import store from '../../../store'
import API from '../API/API'

export function loadSettings () {
  let apiBase = '/api/portal/1.0/'

  if (process.env.NODE_ENV === 'development') {
    apiBase = 'http://localhost:8081' + apiBase
  }

  let staticSettings = {
    title: 'Installation portal',
    collapsegui: '768',
    api_base: apiBase
  }
  store.dispatch({
    type: 'SET_CONFIG',
    payload: staticSettings
  })

  return new Promise((resolve, reject) => {
    API.get('settings/', undefined, undefined).then(settings => {
      store.dispatch({
        type: 'SET_CONFIG',
        payload: Object.assign({}, settings.data, staticSettings.data)
      })
      resolve(settings)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/config/loadSettings.js